import React from 'react'
import { LoaderBar } from 'components'
import { formatApprovalDate } from './report-approval-utils'
import { FinalPill, SectionCard, TimelineItem, TimelineList } from './report-approval-styles'

export const ApprovalHistory = ({
    events = [],
    loading = false,
    title = 'Approval history',
}) => {
    if (loading) {
        return <LoaderBar content="Loading approval history…" />
    }

    if (!events.length) {
        return null
    }

    return (
        <SectionCard>
            <h4
                style={{
                    margin: '0 0 14px',
                    fontSize: 16,
                    color: '#2563eb',
                    borderBottom: '1px solid #e5e7eb',
                    paddingBottom: 6,
                }}
            >
                {title}
            </h4>
            <TimelineList>
                {events.map((event, index) => (
                    <TimelineItem
                        key={event.id || `${event.title}-${index}`}
                        $kind={event.kind}
                    >
                        <span className="dot" />
                        <div className="title">
                            {event.title}
                            {event.role ? ` — ${event.role}` : ''}
                            {event.isFinal && <FinalPill>FINAL</FinalPill>}
                        </div>
                        <div className="meta">
                            {event.actorName ? `${event.actorName} · ` : ''}
                            {event.at
                                ? formatApprovalDate(event.at)
                                : event.meta || 'Not started yet'}
                        </div>
                        {event.signatureUrl && (
                            <div className="signature">
                                <img src={event.signatureUrl} alt="Signature" />
                            </div>
                        )}
                        {!event.signatureUrl && event.signatureText && (
                            <div className="signature">{event.signatureText}</div>
                        )}
                        {event.notes ? <div className="note">“{event.notes}”</div> : null}
                    </TimelineItem>
                ))}
            </TimelineList>
        </SectionCard>
    )
}
